import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { CreateActionContext } from "./CreateActionContext";

function useStore() {
  const { element, setBackendFormErrors } = useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    // Mapear delivery_note_lines de vuelta a invoice_lines antes de enviar
    const dataToSend = { ...element };
    if (dataToSend.delivery_note_lines) {
      dataToSend.invoice_lines = dataToSend.delivery_note_lines;
      delete dataToSend.delivery_note_lines;
    }
    if (dataToSend.delivery_note_type_id) {
      dataToSend.invoice_type_id = dataToSend.delivery_note_type_id;
      delete dataToSend.delivery_note_type_id;
    }
    
    store("invoices", dataToSend)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useStore;
